import React from 'react';

import Container from 'react-bootstrap/Container';

import TenderQuote from 'modules/tender';

const TenderPage = React.memo(() => {
  return (
    <Container className="mt-4">
      <TenderQuote />
    </Container>
  );
});

export default TenderPage;
